import React, { useState } from "react";
import { useTenantStore } from "../../stores/TenantStore";
import { Box, Grid, useTheme } from '@mui/material';
import RsHeader from "./RsHeader";
import RsVisitor from "./RsVisitor";
import RsCheckbox from "./RsCheckbox";
import SignatureButton from "./SignatureButton";
import Signature from "./Signature"
import RsSummary from "./RsSummary";
import ModalContainer from "../layout/ModalContainer";
import RsFellowTravelers from "./RsFellowTravelers";
import RsTravelGroup from "./RsTravelGroup";
import GridContainer from "../layout/GridContainer";
import AppContainer from "../layout/AppContainer";
import CloseButton from "../shared/CloseButton";

const RegistrationSheet = () => {
  const theme = useTheme()
  const {
    tenant, dispatchTenant, updateActiveState
  } = useTenantStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const toggleGuestCardAgreement = () => {
    dispatchTenant({ type: "UPDATE_GUESTCARD_CONSENT", payload: !tenant.registrationSheetData.registrationSheet.guestCardAgreement.consented })
  };

  const toggleAdvertisingAgreement = () => {
    dispatchTenant({ type: "UPDATE_ADVERT_CONSENT", payload: !tenant.registrationSheetData.registrationSheet.advertisingAgreement.consented })
  };

  return (
    <AppContainer>
      <GridContainer>
        <Box style={{ position: "absolute", top:10, right: 0, zIndex: 100, }} mt= {{xs: 2, md: 4}}>
          <CloseButton onClick={() => updateActiveState("emptyResponse")} />
        </Box>
        <ModalContainer open={isModalOpen} handleClose={handleClose} positioned>
          <Signature handleCancel={handleClose} />
        </ModalContainer>
        <Grid item xs={12} mt={3}>
          <RsHeader
            company={tenant.registrationSheetData.company}
            registrationSheet={tenant.registrationSheetData.registrationSheet}
          />
        </Grid>
        <Grid item xs={12}>
          <RsVisitor visitor={tenant.registrationSheetData.registrationSheet.visitor} />
        </Grid>
        {(tenant.registrationSheetData.registrationSheet.companions && tenant.registrationSheetData.registrationSheet.companions.length > 0) &&
          <Grid item xs={12}>
            <RsFellowTravelers companions={tenant.registrationSheetData.registrationSheet.companions} />
          </Grid>
        }
        {tenant.registrationSheetData.registrationSheet.isTravelGroup &&
          <Grid item xs={12}>
            <RsTravelGroup originCountries={tenant.registrationSheetData.registrationSheet.originCountries} />
          </Grid>
        }
        <Grid item xs={12}>
          <RsSummary registrationSheet={tenant.registrationSheetData.registrationSheet} />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item>
              <RsCheckbox
                title="Zustimmung G&auml;stekarte / consent to guest card"
                text={tenant.registrationSheetData.registrationSheet.guestCardAgreement.text}
                consented={tenant.registrationSheetData.registrationSheet.guestCardAgreement.consented}
                onChange={toggleGuestCardAgreement} />
            </Grid>
            <Grid item>
              <RsCheckbox
                title="Zustimmung Zusendung von Informationen / consent to receive information"
                text={tenant.registrationSheetData.registrationSheet.advertisingAgreement.text}
                consented={tenant.registrationSheetData.registrationSheet.advertisingAgreement.consented}
                onChange={toggleAdvertisingAgreement} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="center">
            <SignatureButton onClick={handleOpen} />
          </Box>
        </Grid>
      </GridContainer>
    </AppContainer>
  );
};

export default RegistrationSheet;
